export var GET_ALL_POTENTIALS = '[Potentials] Get All';
export var GET_ALL_POTENTIALS_SUCCESS = '[Potentials] Get All Success';
export var GET_ALL_POTENTIALS_ERROR = '[Potentials] Get All Error';
export var GET_POTENTIAL = '[Potentials] Get Potential';
export var GET_POTENTIAL_SUCCESS = '[Potentials] Get Potential Success';
export var GET_POTENTIAL_ERROR = '[Potentials] Get Potential Error';
export var APPROVE_POTENTIAL = '[Potential] Approve';
export var REJECT_POTENTIAL = '[Potential] Reject';
export var UPDATE_POTENTIAL_SUCCESS = '[Potential] Update Success';
export var UPDATE_POTENTIAL_ERROR = '[Potential] Update Error';
var GetAllPotentials = /** @class */ (function () {
    function GetAllPotentials() {
        this.type = GET_ALL_POTENTIALS;
    }
    return GetAllPotentials;
}());
export { GetAllPotentials };
var GetAllPotentialsSuccess = /** @class */ (function () {
    function GetAllPotentialsSuccess(payload) {
        this.payload = payload;
        this.type = GET_ALL_POTENTIALS_SUCCESS;
    }
    return GetAllPotentialsSuccess;
}());
export { GetAllPotentialsSuccess };
var GetAllPotentialsError = /** @class */ (function () {
    function GetAllPotentialsError(payload) {
        this.payload = payload;
        this.type = GET_ALL_POTENTIALS_ERROR;
    }
    return GetAllPotentialsError;
}());
export { GetAllPotentialsError };
var GetPotential = /** @class */ (function () {
    function GetPotential(payload) {
        this.payload = payload;
        this.type = GET_POTENTIAL;
    }
    return GetPotential;
}());
export { GetPotential };
var GetPotentialSuccess = /** @class */ (function () {
    function GetPotentialSuccess(payload) {
        this.payload = payload;
        this.type = GET_POTENTIAL_SUCCESS;
    }
    return GetPotentialSuccess;
}());
export { GetPotentialSuccess };
var GetPotentialError = /** @class */ (function () {
    function GetPotentialError(payload) {
        this.payload = payload;
        this.type = GET_POTENTIAL_ERROR;
    }
    return GetPotentialError;
}());
export { GetPotentialError };
var ApprovePotential = /** @class */ (function () {
    function ApprovePotential(payload) {
        this.payload = payload;
        this.type = APPROVE_POTENTIAL;
    }
    return ApprovePotential;
}());
export { ApprovePotential };
var RejectPotential = /** @class */ (function () {
    function RejectPotential(payload) {
        this.payload = payload;
        this.type = REJECT_POTENTIAL;
    }
    return RejectPotential;
}());
export { RejectPotential };
var UpdatePotentialSuccess = /** @class */ (function () {
    function UpdatePotentialSuccess(payload) {
        this.payload = payload;
        this.type = UPDATE_POTENTIAL_SUCCESS;
    }
    return UpdatePotentialSuccess;
}());
export { UpdatePotentialSuccess };
var UpdatePotentialError = /** @class */ (function () {
    function UpdatePotentialError(payload) {
        this.payload = payload;
        this.type = UPDATE_POTENTIAL_ERROR;
    }
    return UpdatePotentialError;
}());
export { UpdatePotentialError };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/potentials/store/actions/potential.action.ts.pre-build-optimizer.js